<template>
  <div v-if="items.length">
    <button
      v-for="(notification, index) in items"
      :key="rowKey(notification, index)"
      type="button"
      class="flex w-full gap-3 border-b border-gray-100 px-3 py-3 text-left last:border-0 hover:bg-gray-50"
      @click="onOpen(notification)"
    >
      <span
        class="mt-0.5 flex h-8 w-8 shrink-0 items-center justify-center rounded-full text-sm"
        :class="meta(notification).iconClass"
      >
        <i :class="meta(notification).icon"></i>
      </span>
      <span class="min-w-0 flex-1">
        <span class="flex items-start justify-between gap-3">
          <span class="text-sm font-medium text-gray-800">{{ meta(notification).title }}</span>
          <span class="shrink-0 text-[11px] text-gray-400">{{ formatNotificationTime(notification.requested_at) }}</span>
        </span>
        <span v-if="meta(notification).detail" class="mt-0.5 block text-sm text-gray-600">
          {{ meta(notification).detail }}
        </span>
        <span v-if="meta(notification).destination" class="mt-1 inline-flex items-center gap-1 text-xs font-medium text-sky-700">
          {{ meta(notification).destination }}
          <i class="fa-solid fa-arrow-right text-[10px]"></i>
        </span>
      </span>
    </button>
  </div>
  <p v-else class="px-4 py-6 text-center text-sm text-gray-500">Nuk ka njoftime të reja</p>
</template>

<script setup>
import { computed } from "vue";
import { useRouter } from "vue-router";
import { useMenuStore } from "@/stores/menu";
import { formatNotificationTime, notificationMeta, openNotification } from "./notificationActions";

const router = useRouter();
const menuStore = useMenuStore();
const items = computed(() => menuStore.visible_notifications);

function meta(notification) {
  return notificationMeta(notification);
}

function rowKey(notification, index) {
  return notification.discount_request_id || notification.batch_id || notification.guid || notification.sync_id || index;
}

function onOpen(notification) {
  openNotification(router, notification);
}
</script>
